import { openBlock as e, createElementBlock as t, createElementVNode as r } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
const s = {}, c = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function i(l, o) {
  return e(), t("svg", c, o[0] || (o[0] = [
    r("path", {
      d: "M9.99996 5.05835C6.09014 0.261697 1.96282 3.67049 1.90845 7.34598C1.90845 12.8146 8.45287 17.3018 9.99996 17.3018C11.5471 17.3018 18.0915 12.8133 18.0915 7.34339C18.0371 3.6692 13.9098 0.261697 9.99996 5.05835Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const m = /* @__PURE__ */ n(s, [["render", i]]);
export {
  m as L
};
